import {DateTime} from 'luxon';

import {addQueryToPath} from '../../../libs/shared/helpers/src/browser/urlHelpers';
import {ApiMeetingRoomList} from '../../models/api/meetingRoomModel';
import {fetchApiAsync} from '../http/http';

export async function fetchMeetingRoomsAsync(
  companyUrl: string,
  channelId: number,
  rangeStartDateTime: DateTime,
  rangeEndDateTime: DateTime,
) {
  const path = `${companyUrl}/channels/${channelId}/meeting_rooms`;
  const query = {
    range_start: rangeStartDateTime.toISO(),
    range_end: rangeEndDateTime.toISO(),
  };
  const pathAndQuery = addQueryToPath(path, query);

  const meetingRooms = await fetchApiAsync(ApiMeetingRoomList, pathAndQuery);

  return meetingRooms;
}
